import { DB_NAME } from '@/constants/constants';
import { realmApp } from '../realmConfig';

export function getCollection(collectionName: string) {
  const collection = realmApp?.currentUser
    ?.mongoClient('mongodb-atlas')
    .db(DB_NAME)
    .collection(collectionName);
  return collection;
}
